<template>
  <div :class="['version-item', item.current && 'current primary-bdcolor']" @click="handlePreviewVersion">
    <div class="version-title">
      <span class="version-num primary-color primary-bdcolor">{{verNum}}</span>
      <span class="modify-time">{{modifyTime}}</span>
      <span class="updater ellipsis">({{updater}})</span>
      <span v-if="item.current" class="current primary-bgcolor">{{$t('file.version.current')}}</span>
    </div>
    <div class="meta-info">
      <div class="thumb-icon">
        <thumb-icon
          :type="item.type"
          :name="item.name"
          :thumbnail="item.thumbnail"
          :space="item.space"
          :typeIcon="item.type_icon"
        />
      </div>
      <div class="main-info">
        <div class="file-name ellipsis">{{item.name}}</div>
        <div class="size">{{size}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import {i18n} from '@/utils/i18n'
import {formatDate, approxSize} from '@/utils/common'
export default {
  name: 'VersionItem',
  i18n,
  props: {
    item: Object
  },
  data () {
    return {
      verNum: 'V' + this.item.version,
      modifyTime: formatDate(this.item.modified_at * 1000),
      updater: this.item.updater && this.item.updater.name,
      size: approxSize(this.item.size)
    }
  },
  computed: {
    inPreview () {
      return true
    }
  },
  methods: {
    handlePreviewVersion () {
      this.$emit('preview-version', this.item)
    }
  }
}
</script>
<style lang="postcss">
@import 'variables';

.version-item {
  box-sizing: border-box;
  width: 100%;
  height: 90px;
  padding-left: 15px;
  background-color: #fff;

  &.current {
    border-width: 2px;
    border-style: solid;
  }

  & .version-title {
    display: flex;
    align-items: center;
    height: 30px;
    padding-right: 15px;
    border-bottom: 2px solid #e5e7e9;
    font-size: 12px;
    color: var(--secondlyText);

    & span {
      flex: 0 0 auto;
      display: inline-block;
      height: 18px;
      line-height: 18px;
    }

    & .version-num {
      box-sizing: border-box;
      min-width: 40px;
      height: 24px;
      line-height: 20px;
      border-width: 2px;
      border-style: solid;
      font-size: 20px;
      text-align: center;
      transform: scale(.5);
      transform-origin: left center;
      margin-right: -12px;
    }

    & .updater {
      flex: 1 1 auto;
    }

    & .current {
      min-width: 32px;
      height: 16px;
      line-height: 16px;
      text-align: center;
      color: #fff;
    }
  }

  & .meta-info {
    display: flex;
    height: 58px;

    & .thumb-icon {
      flex: 0 0 auto;
      width: 42px;
      height: 58px;
      display: flex;
      align-items: center;

      & svg,
      & img {
        width: 30px;
        height: 30px;
      }
    }

    & .main-info {
      flex: 1 1 auto;
      padding-right: 10px;
      overflow: hidden;

      & .file-name {
        font-size: 16px;
        color: #000;
        margin-top: 10px
      }

      & .size {
        font-size: 12px;
        color: var(--secondlyText);
      }
    }
  }
}
</style>
